<div class="p-grid">
	<div class="p-col-12 p-lg-6 display-12">
		{{ message.action }}
	</div>
	<div class="p-col-12 p-lg-6 display-12">
		{{ app.moment(message.receivedDateTime).format("L LT") }}
	</div>
</div>
<div class="p-grid">
	<div class="p-col display-14">
		{{ message.message }}
	</div>
</div>
